import { CalloutGroup } from './callout/callout-group';
import { DurationInput } from './duration-input/duration-input';
import { EventPresenter } from './info/event-presenter';
import { InfoEditor } from './info/info-editor';
import { InfoPresenter } from './info/info-presenter';
import { LocationPicker } from './map/location-picker';
import { LoginModal } from './auth/login-modal';
import { Recaptcha } from './recaptcha/recaptcha';
import { PageHeader } from './header/page-header';
import { Popover } from './popover/popover';
import { Spinner } from './spinner/spinner';
import { SchedulerSettingEditor } from './scheduler/scheduler-setting-editor';
import { SchedulePresenter } from './schedule/schedule-presenter';
import { CustomRowsEditor } from './schedule/custom-rows-editor';
import { FaSvg} from './icon/fa-svg';
import { PasskeyAuth } from './auth/passkey-auth';
import { InlineEditText } from './inline-edit-text/inline-edit-text';

export const ComponentRegistrations = [
  CalloutGroup,
  DurationInput,
  EventPresenter,
  InfoEditor,
  InfoPresenter,
  LocationPicker,
  LoginModal,
  Recaptcha,
  PageHeader,
  Popover,
  Spinner,
  SchedulerSettingEditor,
  SchedulePresenter,
  CustomRowsEditor,
  FaSvg,
  PasskeyAuth,
  InlineEditText
];
